import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export const getBaseUrl = () => {
    // TODO: Get this from the config or env or somewhere or refactor to config entirely.
    // using process.env.NODE_ENV to determine the base url for now
    return process.env.NODE_ENV === 'production'
        ? 'https://www.wanderu.com'
        : 'http://localhost:3000'
}
